<template>
    <div class="Workbench" style="background-color: #F4F4F4">
        <el-row class="to_greet_row">
            <el-col :span="3"><img :src="this.info.logo"  :onerror="errorImg01"></el-col>
            <el-col :span="7" class="to_greet_box">
                <div class="to_greet"> 您好，{{info.contact}} {{info.gender>1?'先生':'女士'}}欢迎来到首屏好商贸！</div>
                <div class="to_greet_name"><a style="color: black;" :href="'https://www.ishouping.com/qiye/'+info.b_id" target="_blank">{{info.b_name}}</a></div>
            </el-col>
            <el-col class="workbench_time" :span="8" :offset="6">会员有效期：{{info.member_start_time !='0000-00-00 00:00:00'?info.member_start_time:''}}~{{info.member_timeout}}</el-col>
        </el-row>
        <el-row>
            <el-col class="quick_name" :span="3" style="text-align: center">快捷功能</el-col>
        </el-row>
        <el-row class="quick" :gutter="24">
            <el-col :span="4"><a :href="total.sale_link"><img src="../assets/img/home/onsale.png" style="margin-top: 10px;"></a>
                <div class="quick_title">在售商品（{{total.sale}}）</div>
            </el-col>
            <el-col :span="4"><a :href="total.check_link"><img src="../assets/img/home/review.png" alt="" style="margin-top: 10px;"></a>
                <div class="quick_title">审核商品（{{total.check}}）</div>
            </el-col>
            <el-col :span="4"><a :href="total.nopass_link"><img src="../assets/img/home/reject.png" alt="" style="margin-top: 10px;"></a>
                <div class="quick_title">拒审商品（{{total.noPass}}）</div>
            </el-col>
            <el-col :span="4"><a :href="total.pub_link"><img src="../assets/img/home/pub.png" alt="" style="margin-top: 10px;"></a>
                <div class="quick_title">商品发布</div>
            </el-col>
            <el-col :span="4"><a :href="total.xp_link"><img src="../assets/img/home/xp.png" alt="" style="margin-top: 10px;"></a>
                <div class="quick_title">我的询盘（{{total.xp}}）</div>
            </el-col>
            <el-col :span="4"><a :href="total.deco_link"><img src="../assets/img/home/deco.png" alt="" style="margin-top: 10px;"></a>
                <div class="quick_title">店铺装修</div>
            </el-col>
            <el-col :span="4"><a :href="url"><img src="../assets/img/home/xp.png" alt="" style="margin-top: 10px;"></a>
              <div class="quick_title">店铺分查询</div>
            </el-col>
            <el-col :span="4"><a @click="submitMeet"><img src="../assets/img/home/quan.jpg" alt="" style="margin-top: 10px;"></a>
                <div class="quick_title">优惠券查询</div>
            </el-col>
            <el-col :span="4"><a href="https://b2bwork.baidu.com/serv_message" target="_blank"><img src="../assets/img/home/xp.png" alt="" style="margin-top: 10px;"></a>
                <div class="quick_title">爱采购消息中心</div>
            </el-col>

        </el-row>
        <el-dialog title="优惠券" :visible.sync="handleDialog">
            <el-table
                    :data="meet.result" empty-text="没有优惠活动"
                    style="width: 100%">
                <el-table-column label="券名" prop="preferential">
                    <template slot-scope="scope">
                        <span :title="scope.row.preferential">{{scope.row.preferential}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="已用" prop="use_num" width="100"></el-table-column>
                <el-table-column label="剩余" prop="remain_num" width="100"></el-table-column>
                <el-table-column label="使用地区" width="180" prop="preferential_area">
                  <template slot-scope="scope">
                    <span v-if="scope.row.preferential_area === ''">无限制</span>
                    <span v-if="scope.row.preferential_area !== ''">{{scope.row.preferential_area}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="right">
                      <template slot="header" slot-scope="scope">
                          <el-input v-model="meet.company" size="mini" placeholder="回车搜索" @keyup.enter.native="submitMeet"></el-input>
                      </template>
                      <template slot-scope="scope">
                          {{scope.row.start_time}}<br/>{{scope.row.end_time}}
                      </template>
                  </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                meet:{company:"",b_id:"",result:[]},
                handleDialog:false,
                info: {logo:"" , b_name: '', contact: "", gender: 1, member_timeout: ''},
                errorImg01: 'this.src="' + require("../assets/img/yyzz.png") + '"',
                total: {
                    sale: "",
                    check: "",
                    noPass: "",
                    publish: "",
                    sale_link: "",
                    check_link: "",
                    nopass_link: "",
                    pub_link: "",
                    xp: "",
                    xp_link: "",
                    deco_link: ""
                },
                url:'/index/page/store/Index',
            };
        },
        mounted() {
            this.initInfo();
        },
        methods: {
            submitMeet(){
                this.handleDialog = true
                let that = this;
                this.$ajax.post(this.$work_host+'/index.php/admin/login/meet',this.meet).then(function (res) {
                    if (res.data.error === 0) {
                        that.meet.result = res.data.data
                    }
                });
            },
            initInfo() {
                let that = this;
                this.$ajax.get('admin/home/getInfo').then(function (res) {
                    if (res.data.error === 0) {
                        that.info = res.data.data.info
                        that.meet.company = res.data.data.info.b_name
                        that.meet.b_id = res.data.data.info.b_id
                        localStorage.setItem("org_b_id", res.data.data.info.b_id);
                        that.total = res.data.data.total
                    }
                });
//                this.$router.push({
//                    path: 'goods/Index:sales_status',
//                    query: {
//                        sales_status: sales_status,
//                    }
//                });
//                this.$router.push({
//                    path: 'goods/Index:review_status',
//                    query: {
//                        review_status: review_status,
//                    }
//                });
//                this.$router.push({
//                    path: 'goods/Index:is_add',
//                    query: {
//                        is_add: is_add,
//                    }
//                });
            }
        }
    };
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/Home.vue